import React, { PureComponent, createRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import pages from './Pages';
import Footer from "../Footer";
import Header from "../Header";

import { set_go_to_page } from '../../../actions';

import { PortfolioPage, userMenu } from "../../../Constants/user";

import './style.scss';

class Portfolio extends PureComponent {
    constructor(props) {
        super(props);

        props.active(Object.keys(userMenu[0].menuList).findIndex(i => i === 'portfolio'));

        let firstLang = props.lang || 'en';
        let language = PortfolioPage.find(el => el.lang === firstLang);

        document.title = language.title;

        this.state = {
            language,
            lang: props.lang,
        };

        this.ref = createRef();
    }

    static getDerivedStateFromProps(props, state) {
        let language = PortfolioPage.find(el => el.lang === props.lang);
        document.title = language.title;

        return {
            ...state,
            lang: props.lang,
            initialized: true,
            language,
        }
    }

    render() {
        const { setLanguage, language, activeMenu, page, isLoading, width } = this.props;
        const Component = pages[page].component;

        return (
            <div id="portfolioPage">
                <div id={'left'}>
                    {width > 1024 ? (
                        <Link to={'/'}><img src={'/images/userPage/desktop/Logo for web.png'} alt /></Link>
                    ) : (
                        <Link to={'/'}><img src={'/images/userPage/tablet/Logo2.png'} alt /></Link>
                    )}
                </div>
                <div id={'right'}>
                    <Header userMenu={userMenu} setLanguage={setLanguage} language={language} active={activeMenu}/>
                    <div id={'container'} ref={this.ref} >
                        <div id={'containerInner'}>
                            <div id={'textPart'}>
                                <Component componentRef={this.ref} />
                            </div>
                            <Footer language={language}/>
                        </div>
                    </div>
                </div>
                {isLoading && (
                    <div id="overLay">
                        <img src={'/images/userPage/loading.gif'} alt/>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = ({ portfolio: { page, isLoading }, main: { width } }) => ({
    page,
    width,
    isLoading,
});

const mapDispatchToProps = dispatch => ({
   setGoToPage: fn => dispatch(set_go_to_page(fn)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
